var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4937 6.46129C15.793 5.60941 13.9124 5.16235 12 5.16235C9.71116 5.16235 7.46797 5.80271 5.52406 7.01103C4.00089 7.95781 2.70908 9.22371 1.73387 10.7147C1.22294 11.4959 1.22294 12.5038 1.73387 13.285C2.70908 14.776 4.00089 16.0419 5.52406 16.9887C5.82108 17.1733 6.12509 17.3447 6.43518 17.5025M9.51779 18.5836C10.3308 18.7516 11.1623 18.8373 12 18.8373C14.2888 18.8373 16.532 18.197 18.4759 16.9887C19.9991 16.0419 21.2909 14.776 22.2661 13.285C22.7771 12.5038 22.7771 11.4959 22.2661 10.7147C21.6391 9.75603 20.8811 8.8904 20.015 8.14282",
    stroke: "#717680",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6428 14.31C9.05913 13.7147 8.69922 12.8992 8.69922 11.9997C8.69922 10.1772 10.1767 8.69971 11.9992 8.69971C12.875 8.69971 13.6711 9.04087 14.2619 9.59755",
    stroke: "#717680",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6406 15.2376C13.9704 14.9757 15.0134 13.9151 15.2492 12.5762",
    stroke: "#717680",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7773 4.22168L4.221 19.778",
    stroke: "#717680",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide24Px);
export default __webpack_public_path__ + "static/media/Hide_24px.57a93ffe456b4d785caa22c8968b7393.svg";
export { ForwardRef as ReactComponent };